import React, { useEffect, useRef, useState } from "react";
import { getStatus } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { addSkill } from "../../Services/SkillService";
import { toBase64 } from "../../Services/commonHelper";

const AddSkill = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        name: "",
        description: "",
        status_id: "",
        id: "",
        icon: "",
        help_description: "",
        meta_description: "",
        title: "",
        sort_order: ""
    });
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState([]);
    const navigate = useNavigate();
    const [previewImage, setPreviewImage] = useState({
        icon: ""
    });
    const uploadIconRef = useRef(null);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await addSkill(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const handleImport = async (e, field) => {
        const file = e.target.files[0];
        e.target.value = "";
        if (file?.type?.includes("image/jpeg") || file?.type?.includes("image/png")) {
            let base64String = await toBase64(file);
            handleChange(field, base64String);
            setPreviewImage({ ...previewImage, [field]: URL?.createObjectURL(file) });
        } else {
            toast.error("Image must ba valid .jpeg file")
        }
    };

    const getStatusCall = async () => {
        let { ok, data } = await getStatus({});
        if (ok) {
            setStatus(data?.records);
        }
    };

    const redirect = (url) => {
        navigate(url, { state: reqData })
    };

    useEffect(() => {
        getStatusCall();
        if (data?.data) {
            const { alias, status_name, ...rest } = data?.data;
            setReqData(rest)
        }
    }, []);

    return (
        <div
            className="modal modal-fullscreen custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Skill" : "Edit Skill"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required
                                                value={reqData?.name}
                                                onChange={(e) => handleChange("name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Title"
                                                required
                                                value={reqData?.title}
                                                onChange={(e) => handleChange("title", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select required value={reqData?.status_id} onChange={(e) => handleChange("status_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Status</option>
                                                {status?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Description"
                                                required
                                                value={reqData?.description}
                                                onChange={(e) => handleChange("description", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Help Description</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Help Description"
                                                value={reqData?.help_description}
                                                onChange={(e) => handleChange("help_description", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Meta Description</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Meta Description"
                                                value={reqData?.meta_description}
                                                onChange={(e) => handleChange("meta_description", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Sort Order</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Sort Order"
                                                value={reqData?.sort_order}
                                                onChange={(e) => handleChange("sort_order", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="mb-3 d-flex bank-details-btn">
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadIconRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.icon ? "Change Icon" : "Add Icon"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.icon || reqData?.icon) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Flag Image"
                                                src={previewImage?.icon ? previewImage?.icon : reqData?.icon}
                                            />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn me-2"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                                {reqData?.id &&
                                    <>
                                        <button
                                            className="btn bank-save-btn me-2"
                                            disabled={loader}
                                            onClick={() => redirect("/skill/benefits")}
                                        >
                                            Benefits
                                        </button>
                                        <button
                                            className="btn bank-save-btn me-2 secondary"
                                            disabled={loader}
                                            onClick={() => redirect("/skill/media")}
                                        >
                                            Media
                                        </button>
                                        <button
                                            className="btn bank-save-btn me-2 secondary"
                                            disabled={loader}
                                            onClick={() => redirect("/skill/quizes")}
                                        >
                                            Quiz
                                        </button>
                                    </>
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </form>
            <input hidden ref={uploadIconRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "icon")} />
        </div>
    );
};

export default AddSkill;